module.exports = __webpack_public_path__ + "static/media/6.34deb873.jpg";